import { gql } from "@apollo/client";

export const SPACELIFT_VCS_REPO_BASIC_FRAGMENT = gql`
  fragment SpaceliftVcsRepoBasic on Repo {
    id
    name
    slug
    description
    createdAt
    labels
    commits(first: 1) {
      edges {
        node {
          sha
        }
      }
    }
    space {
      id
      name
    }
  }
`;
